const baseSfdcConnectorUrl = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_VTU}`;
const temporarysfdc = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SFDC}`;
export const GETSALESFORCECASES = `${temporarysfdc}/cases`;
export const GETBYACCOUNTNUMBER = `${temporarysfdc}/account/accountNumber`; //I will change this (once api is ready in account-service) backend needs to be fixed because new fields are going to be added .
